/* eslint-disable camelcase */
import axios from "axios";
//Limitless
import { formatSimpleDate, ClientContext } from "@limitless/common/utils";
import { createPublicAPIRequest } from "@limitless/common/utils/PublicAPIUtils";
import { handleAPIFailure } from "@limitless/common/utils/api-log-helper/APILogHelper";
export const fetchGroupResponseTime = callback => {
  const date = new Date();
  const dayYear = `${formatSimpleDate(date, {
    pattern: "DDD"
  })}-${date.getFullYear()}`;
  const queryParams = {
    groups: ClientContext._groupName,
    view: "day",
    day_number: dayYear,
    stats: "group.response.avgTime",
    readonly: true,
    requester: "customer"
  };
  const apiConfig = createPublicAPIRequest("get", "stats/groups", queryParams);

  //Ajax call URL, payload, config
  axios(apiConfig).then(response => {
    const date = new Date();
    let dayData = 0;
    try {
      dayData = response.data[0].children[date.getFullYear()][0][formatSimpleDate(date, {
        pattern: "D"
      })];
    } catch (event) {
      dayData = 0;
    }
    callback({
      time: dayData
    });
  }).catch(error => {
    handleAPIFailure(error, "GroupResponseTimeAPI fetchGroupResponseTime");
    callback({
      time: 0
    });
  });
};